/**
 * Отправка формы с перезагрузкой страницы
 */
export const postForm = (url: string, data: Record<string, string>) => {
  const form = document.createElement("form");
  form.setAttribute("id", "fake-form");
  form.setAttribute("action", url);
  form.setAttribute("method", "POST");

  Object.entries(data).forEach(([key, value]) => {
    const input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", key);
    input.setAttribute("value", value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};
